var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-combobox", {
        ref: _vm.param.name,
        class: { dense_input: _vm.dense },
        attrs: {
          items: [],
          "small-chips": "",
          "hide-selected": "",
          multiple: _vm.multiple,
          rules: [].concat(_vm.rules),
          hint: _vm.hint,
          type: "number",
          solo: _vm.solo,
          value: _vm.value,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          placeholder: _vm.placeholder ? "Programme" : null,
          "append-icon": "search"
        },
        on: {
          change: function($event) {
            return _vm.onCardChange($event)
          },
          "click:append": function($event) {
            _vm.explorer_show = true
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [
                !_vm.param.hide_label
                  ? _c("span", [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm._f("maestroParamLabel")(_vm.param)) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e()
              ]
            },
            proxy: true
          },
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              return [
                item
                  ? _c(
                      "span",
                      [
                        _vm.labels[item] === "loading"
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "input-chips",
                                attrs: {
                                  label: "",
                                  outline: "",
                                  small: "",
                                  color: "primary"
                                }
                              },
                              [
                                _c("span", { staticClass: "label-id" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(item) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("v-progress-circular", {
                                  attrs: {
                                    indeterminate: "",
                                    color: "background",
                                    size: 20,
                                    width: 2
                                  }
                                })
                              ],
                              1
                            )
                          : _vm.labels[item]
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "input-chips",
                                attrs: {
                                  label: "",
                                  outline: "",
                                  small: "",
                                  color: "success lighten-1"
                                }
                              },
                              [
                                _vm.labels[item]
                                  ? _c("span", { staticClass: "pr-2" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(_vm.labels[item]) +
                                          "\n\t\t\t\t\t"
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "label-id" }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(item) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.disabled && !_vm.readonly
                                  ? _c(
                                      "span",
                                      [
                                        _vm.multiple
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: { small: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeCard(item)
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\tclose\n\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                attrs: { small: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$emit(
                                                      "change",
                                                      ""
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\tclose\n\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _c(
                              "v-chip",
                              {
                                staticClass: "input-chips",
                                attrs: { label: "", small: "", color: "error" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t"
                                ),
                                !_vm.disabled && !_vm.readonly
                                  ? _c(
                                      "span",
                                      [
                                        _vm.multiple
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: { small: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeCard(item)
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\tclose\n\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                attrs: { small: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$emit(
                                                      "change",
                                                      ""
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\tclose\n\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.explorer_show
        ? _c(
            "Babel",
            {
              attrs: {
                multiselect: _vm.multiple,
                toolbarTitle: _vm.param.name,
                card_type: _vm.card_type
              },
              on: {
                close: function($event) {
                  _vm.explorer_show = false
                },
                selected: function($event) {
                  return _vm.onCardsSelected($event)
                }
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("Babel ID(s) Select for Maestro ingester")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d31ed276", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d31ed276","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/field_babel_id.vue
// module id = null
// module chunks = 